export default __webpack_public_path__ + "bml-characteristic4.2564dfe.png";